import classNames from 'classnames';
import { useId } from 'hooks';

import './index.css';

function Monogram({ highlight, className, ...props }) {
  const id = useId();
  const linearId = `linear-${id}`;
  const clipId = `monogram-clip-${id}`;

  return (
    <svg
      aria-hidden
      className={classNames('monogram', className)}
      width="45"
      height="45"
      viewBox="0 0 16000 16000"
      {...props}
    >
      <defs>
        <linearGradient id={linearId} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#64bbe8" />
          <stop offset="80%" stopColor="#c5aed3" />
        </linearGradient>
        <clipPath id={clipId}>
        <path  d="m29 5c-13.254834 0-24 10.745166-24 24s10.745166 24 24 24 24-10.745166 24-24c-.0154295-13.2484376-10.7515624-23.98457048-24-24zm12.169 39.763c-.7327897.3100717-1.5587449.3163273-2.2961471.0173906-.7374023-.2989367-1.3258407-.8785758-1.6358529-1.6113906l-2.187-5.169h-12.1l-2.187 5.169c-.4176435.9871249-1.3301868 1.6764557-2.3938837 1.8083283-1.0636969.1318725-2.1169466-.3137478-2.763-1.1690001-.6460535-.8552523-.7867598-1.9902034-.3691163-2.9773282l11-26c.4695193-1.110033 1.5577524-1.8313123 2.763-1.8313123s2.2934807.7212793 2.763 1.8313123l11 26c.3100717.7327897.3163273 1.5587449.0173906 2.2961471-.2989367.7374023-.8785758 1.3258407-1.6113906 1.6358529z"/>

         </clipPath>
      </defs>
      <rect
        clipPath={`url(#${clipId})`}
        fill={`url(#${linearId})`}
        width="100%"
        height="100%"
      />
      {highlight && (
        <g clipPath={`url(#${clipId})`}>
          <rect className="monogram__highlight" width="100%" height="100%" />
        </g>
      )}
    </svg>
  );
}

export default Monogram;
